<template>
  <div v-if="isShown">
    <div class="custom-modal">
      <span class="icon-close" v-on:click="resetModal" />
      <div class="custom-modal-content">
        <component :is="componentContent" v-bind="componentParam" @close-modal="isShown=false"></component>
      </div>
    </div>
    <div class="overlay" @click="resetModal"></div>
  </div>
</template>

<script>
import bus from "../../bus";

import PublishIdeaModal from "../PublishIdeaModal";
import FeedbackModal from "../feedback/FeedbackModal";
import UpdateListTitleModal from "../lists/UpdateListTitleModal";
import ConcludeSessionModal from "../lists/ConcludeSessionModal";

export default {
  components: {
    PublishIdeaModal,
    FeedbackModal,
    UpdateListTitleModal,
    ConcludeSessionModal,
  },
  data() {
    return {
      isShown: false,
      componentContent: {},
      componentParam: {},
    };
  },
  methods: {
    resetModal: function () {
      this.isShown = false;
      bus.$emit("modal-is-closed")
    },
    openModalEvent: function () {
      bus.$on("open-modal", (componentName, paramName, paramContent) => {
        this.componentContent = componentName;
        this.componentParam[paramName] = paramContent;
        this.isShown = true;
      });
    },
    closeModalEvent: function () {
      bus.$on("close-modal", () => {
        this.isShown = false;
      });
    },
  },
  beforeMount: function () {
    this.openModalEvent();
    this.closeModalEvent();
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.custom-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: theme.$white-background;
  padding: theme.$page-padding-top theme.$page-padding-X;
  z-index: 25;
  overflow: scroll;
}

.custom-modal .custom-modal-content {
  margin-top: 40px;
}

.custom-modal span.icon-close {
  cursor: pointer;
  font-size: 24px;
  position: absolute;
  top: 30px;
  right: 30px;
}

@media (min-width: 768px) {
  .custom-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    max-height: 600px;
  }

  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: theme.$dark-grey-background;
    opacity: 0.6;
    padding: 0px theme.$page-padding-X;
    z-index: 15;
  }
}
</style>